import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getCurrentIndustryShapeSets(industryId, isAllocatedTo = true, excludeArchived = true) {
  return function(dispatch, getState) {
    const endpoint = '/shapesets';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        industryId,
        isAllocatedTo,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const shapeSets = response.data.shapeSets;
        if (isAllocatedTo) {
          dispatch({
            type: 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_SHAPESETS',
            shapeSets
          });
        } else {
          dispatch({
            type: 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_SHAPESETS',
            shapeSets
          });
        }
      },
      error => dispatch(APIError(error, 'Error getting currentIndustry Catchment Sets'))
    );
  };
}

export function addShapeSetToIndustry(shapeSetId, industryId) {
  return function(dispatch, getState) {
    const endpoint = '/shapeset/membership/industry';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        shapeSetId,
        industryId
      }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getCurrentIndustryShapeSets(industryId, true));
        dispatch(getCurrentIndustryShapeSets(industryId, false));
      },
      error => dispatch(APIError(error, 'Error adding Catchment Set to currentIndustry'))
    );
  };
}

export function removeShapeSetFromIndustry(shapeSet, industryId) {
  return function(dispatch, getState) {
    const endpoint = `/shapeset/membership/industry/${shapeSet.membershipId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getCurrentIndustryShapeSets(industryId, true));
        dispatch(getCurrentIndustryShapeSets(industryId, false));
      },
      error => dispatch(APIError(error, 'Error removing Catchment Set from currentIndustry'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/industries/shapeSetCreators.js